import React from "react";

const ToggleBlueOn = ({ width, height, color }) => {
  return (
    <svg
      width="53"
      height="26"
      viewBox="0 0 53 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="53" height="26" rx="13" fill="#00008B" />
      <circle cx="40" cy="13" r="10" fill="white" />
    </svg>
  );
};
export default ToggleBlueOn;
